import { useContext } from 'react';
import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';
import isMobile from 'ismobilejs';
import { ChatInstance } from '@trinity/chat-components/components/Chat/Chat';
import {
  GetStartedContext,
  ChatGetStarted,
} from '@trinity/chat-components/components/Chat.GetStarted/index.js';
import { ChatHeader } from '@trinity/chat-components/components/Chat.Header';
import { Constants, useTheme } from '@trinity/chat-components/components/Theme';
import { ChatSettingsToggleContext } from '@trinity/chat-components/components/Chat/context';
import { Close } from './Close';
import { ChatSettings } from '../Chat.Screen/Chat.Setting';
import { ChatSidebar, EmptySidebar } from '../Chat.Screen/Sidebar';
import { useMonitorChatIdentifier } from '@trinity/chat-components/containers/Chat/useMonitorHashChatIdentifier';

export type ChatModalProps = {
  onClose: () => void;
  open: boolean;
  className?: string;
};

export const ChatModal = ({ open, onClose, className }: ChatModalProps) => {
  const device = isMobile();
  const theme = useTheme();

  const [showGetStarted, dismissGetStarted] = useContext(GetStartedContext);
  const showSideBar = !device.phone;
  const showHeader = !device.phone;

  useMonitorChatIdentifier();

  const [settings] = useContext(ChatSettingsToggleContext);

  return (
    <Dialog
      className={className}
      fullScreen={device.phone ? true : false}
      fullWidth={device.phone ? false : true}
      maxWidth={device.phone ? false : 'md'}
      onClose={onClose}
      sx={{
        zIndex: theme.zIndex.baseModal,
      }}
      PaperProps={{
        sx: {
          overflow: 'inherit !important',
          maxWidth: '1100px',
          maxHeight: '100vh',
        },
      }}
      open={open}
    >
      <Root>
        {showSideBar && <Sidebar />}
        <Wrap>
          {!settings && showHeader && <ChatHeader />}
          {settings ? (
            <ChatSettings />
          ) : showGetStarted ? (
            <StyledGetStarted onClick={dismissGetStarted} />
          ) : (
            <ChatInstance />
          )}
        </Wrap>
        {showSideBar && <StyledClose onClick={onClose} />}
      </Root>
    </Dialog>
  );
};

const Sidebar = () => {
  const [showGetStarted] = useContext(GetStartedContext);

  if (showGetStarted) {
    return <EmptySidebar />;
  } else {
    return <ChatSidebar />;
  }
};

const Root = styled.div(({ theme }) => ({
  position: 'relative',
  display: 'flex',

  height: '98vh',
  backgroundColor: theme.palette.secondary.main,
  borderRadius: `${Constants.Modal.BorderRadius}px`,
}));

const Wrap = styled.div(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  minWidth: 0,
  backgroundColor: theme.palette.white.main,
}));

const closeOffset = -20;

const StyledClose = styled(Close)({
  position: 'absolute',
  right: `${closeOffset}px`,
  top: `${closeOffset}px`,
});

const StyledGetStarted = styled(ChatGetStarted)({
  marginTop: 30,
});
